module.exports = __webpack_public_path__ + "img/seal4.1075ed0c.png";